import type { Maybe } from '@adornis/base/utilTypes.js';
import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import { getPasswordResetLink } from '@adornis/users/server/password.js';
import { config } from '@ils/config/config.js';
import { EmailAttachments, EmailType, EmailVars } from '@ils/mails/emailEnums.js';
import type { ExamType } from '@ils/static/enums.js';
import { Names } from '@ils/static/names.js';
import { html } from 'lit';
import { getSalutation } from '../utils.js';

export const WelcomeEmail = defineMailTemplate(EmailType.WELCOME, {
  displayName: EmailType.WELCOME,
  defaultTemplate: {
    subject: 'Anmeldung Erfolgreich',
    content: `
<p>Herzlichen Glückwunsch Sie haben erfolgreich Ihren Account erstellt.</p>
<p>Sie erhalten eine zweite E-Mail sobald Sie Ihren Kaufvorgang abgeschlossen haben.</p>
<p>Viele Grüße, Ihr FaMed-Team</p>`,
    footer: '',
  },
  variables: [],
  attachments: [EmailAttachments.INFO_PDF],
  editorHint: () => html`
    <p>
      Wird gesendet an:<br />
      - Prüfling
    </p>
    <p>
      Wann:<br />
      - sobald der Account erstellt wurde (vor der Bezahlung)
    </p>
  `,
  getMailData: (firstName: string, lastName: string, examType?: ExamType) => ({
    data: {
      [EmailVars.FIRSTNAME]: firstName,
      [EmailVars.LASTNAME]: lastName,
    },
    scope: examType,
  }),
});

export const PasswordResetMail = defineMailTemplate(EmailType.RESET_PASSWORD, {
  displayName: EmailType.RESET_PASSWORD,
  defaultTemplate: {
    subject: 'FaMed Password zurücksetzen',
    content: `
<p>Sehr geehrte/r {{${EmailVars.SALUTATION}}} {{${EmailVars.LASTNAME}}}</p>
<p>Jemand hat ein neues Passwort für Ihr FaMed Konto angefordert.</p>
<p>Wenn Sie das nicht waren ignorieren Sie diese E-Mail oder wenden Sie sich an uns unter <a>${config.get(
      'TECHNICALSUPPORTMAIL',
    )}</a>.</p>
<p>Wenn Sie Ihr Password zurücksetzen wollen klicken Sie <a href="{{${EmailVars.RESET_LINK}}}">hier</a>.</p>
`,
    footer: '',
  },
  variables: [EmailVars.SALUTATION, EmailVars.LASTNAME, EmailVars.RESET_LINK],
  attachments: [],
  editorHint: () => html`
    <p>
      Wird gesendet an:<br />
      - Alle Nutzer
    </p>
    <p>
      Wann:<br />
      - wenn der jeweilige Nutzer ein neues Passwort anfordert
    </p>
  `,
  getMailData: async (user: {
    _id: string;
    username: string;
    ecommerce?: Maybe<{ firstName: string; lastName: string }>;
    profile?: Maybe<{ gender: string }>;
  }) => ({
    data: {
      [EmailVars.SALUTATION]: getSalutation(user),
      [EmailVars.LASTNAME]: user.ecommerce?.lastName ?? user.username,
      [EmailVars.RESET_LINK]: await getPasswordResetLink('reset-password', {
        ttl: 300000,
        ttu: 1,
        userClass: Names.ILSUser._class,
        userID: user._id,
      }),
    },
  }),
});
